import retranslationsService from "../shared/services/retranslationsService";

const REQUEST_RETRANSLATIONS = "REQUEST_RETRANSLATIONS";
const RESPONSE_RETRANSLATIONS = "RESPONSE_RETRANSLATIONS";
const REQUEST_RETRANSLATIONS_FAILURE = "REQUEST_RETRANSLATIONS_FAILURE";

const requestRetranslationsAction = () => {
  return {
    type: REQUEST_RETRANSLATIONS,
  };
};

const responseRetranslationsAction = (data) => {
  return {
    type: RESPONSE_RETRANSLATIONS,
    data,
  };
};

const requestRetranslationsFailureAction = (errors) => {
  return {
    type: REQUEST_RETRANSLATIONS_FAILURE,
    errors,
  };
};

const getRetranslations = () => {
  return (dispatch) => {
    dispatch(requestRetranslationsAction());

    retranslationsService
      .getRetranslations()
      .then((result) => {
        dispatch(responseRetranslationsAction(result.data));
      })
      .catch((error) => {
        dispatch(requestRetranslationsFailureAction(error.response));
      });
  };
};

const REQUEST_RETRANSLATIONS_TYPES = "REQUEST_RETRANSLATIONS_TYPES";
const RESPONSE_RETRANSLATIONS_TYPES = "RESPONSE_RETRANSLATIONS_TYPES";
const REQUEST_RETRANSLATIONS_FAILURE_TYPES = "REQUEST_RETRANSLATIONS_FAILURE_TYPES";

const requestRetranslationsTypesAction = () => {
  return {
    type: REQUEST_RETRANSLATIONS_TYPES,
  };
};

const responseRetranslationsTypesAction = (data) => {
  return {
    type: RESPONSE_RETRANSLATIONS_TYPES,
    data,
  };
};

const requestRetranslationsTypesFailureAction = (errors) => {
  return {
    type: REQUEST_RETRANSLATIONS_FAILURE_TYPES,
    errors,
  };
};

const getRetranslationsTypes = () => {
  return (dispatch) => {
    dispatch(requestRetranslationsTypesAction());

    retranslationsService
      .getRetranslationsTypes()
      .then((result) => {
        dispatch(responseRetranslationsTypesAction(result.data));
      })
      .catch((error) => {
        dispatch(requestRetranslationsTypesFailureAction(error.response));
      });
  };
};

const REQUEST_CREATE_RETRANSLATION_UNIT = "REQUEST_CREATE_RETRANSLATION_UNIT";
const RESPONSE_CREATE_RETRANSLATION_UNIT = "RESPONSE_CREATE_RETRANSLATION_UNIT";
const REQUEST_CREATE_RETRANSLATION_UNIT_FAILURE = "REQUEST_CREATE_RETRANSLATION_UNIT_FAILURE";

const requestCreateRetranslationUnitAction = () => {
  return {
    type: REQUEST_CREATE_RETRANSLATION_UNIT,
  };
};

const responseCreateRetranslationUnitAction = (data, companyId) => {
  return {
    type: RESPONSE_CREATE_RETRANSLATION_UNIT,
    data,
    companyId
  };
};

const requestCreateRetranslationUnitFailureAction = (errors) => {
  return {
    type: REQUEST_CREATE_RETRANSLATION_UNIT_FAILURE,
    errors,
  };
};

const createRetranslationUnit = (options, companyId) => {
  return (dispatch) => {
    dispatch(requestCreateRetranslationUnitAction());

    retranslationsService
      .createRetranslationUnit(options)
      .then((result) => {
        dispatch(responseCreateRetranslationUnitAction(options, companyId));
      })
      .catch((error) => {
        dispatch(requestCreateRetranslationUnitFailureAction(error.response));
      });
  };
};

const REQUEST_DELETE_RETRANSLATION_UNIT = "REQUEST_DELETE_RETRANSLATION_UNIT";
const RESPONSE_DELETE_RETRANSLATION_UNIT = "RESPONSE_DELETE_RETRANSLATION_UNIT";
const REQUEST_DELETE_RETRANSLATION_UNIT_FAILURE = "REQUEST_DELETE_RETRANSLATION_UNIT_FAILURE";

const requestDeleteRetranslationUnitAction = () => {
  return {
    type: REQUEST_DELETE_RETRANSLATION_UNIT,
  };
};

const responseDeleteRetranslationUnitAction = (data, companyId) => {
  return {
    type: RESPONSE_DELETE_RETRANSLATION_UNIT,
    data,
    companyId,
  };
};

const requestDeleteRetranslationUnitFailureAction = (errors) => {
  return {
    type: REQUEST_DELETE_RETRANSLATION_UNIT_FAILURE,
    errors,
  };
};

const deleteRetranslationUnit = (options, companyId) => {
  return (dispatch) => {
    dispatch(requestDeleteRetranslationUnitAction());

    retranslationsService
      .deleteRetranslationUnit(options)
      .then((result) => {
        dispatch(responseDeleteRetranslationUnitAction(options, companyId));
      })
      .catch((error) => {
        dispatch(requestDeleteRetranslationUnitFailureAction(error.response));
      });
  };
};

export {
  REQUEST_RETRANSLATIONS,
  RESPONSE_RETRANSLATIONS,
  REQUEST_RETRANSLATIONS_FAILURE,
  getRetranslations,
  REQUEST_RETRANSLATIONS_TYPES,
  RESPONSE_RETRANSLATIONS_TYPES,
  REQUEST_RETRANSLATIONS_FAILURE_TYPES,
  getRetranslationsTypes,
  REQUEST_CREATE_RETRANSLATION_UNIT,
  RESPONSE_CREATE_RETRANSLATION_UNIT,
  REQUEST_CREATE_RETRANSLATION_UNIT_FAILURE,
  createRetranslationUnit,
  REQUEST_DELETE_RETRANSLATION_UNIT,
  RESPONSE_DELETE_RETRANSLATION_UNIT,
  REQUEST_DELETE_RETRANSLATION_UNIT_FAILURE,
  deleteRetranslationUnit,
};
